import React, {useState} from "react";
import { Modal } from "react-bulma-components";
import { Table } from "react-bulma-components";
import { Section } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Button } from "react-bulma-components";
import { Form } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import {Icon} from "react-bulma-components";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import {NotificationManager} from "react-notifications";
import {getQueryString} from "../../utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import AddPartModal from "./AddPartModal";
import PartRow from "./PartRow";
import PartSearchModal from "../Job/PartSearchModal";
import workLookup from "./WorkLookup";

const AsyncTypeahead = asyncContainer(Typeahead);

export default function CreateWorkModal({open, setOpen, endpoint, historicWork}) {
  // const prefilledWork = {
  //   description: historicWork.description,
  //   supplier: historicWork.supplier,
  //   labour_labour_cost: historicWork.labour_labour_cost,
  //   labour_hours: historicWork.labour_labour_cost,
  //
  // } : {vehicle_type: vehicleTypes[0]}

  const dispatch = useDispatch();
  let dataFresh = useSelector(getDataFresh);
  let [work, setWork] = useState( {});
  const [, setTypeahead] = useState();
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [partModalOpen, setPartModalOpen] = useState(false);
  const [partLookupSearchModal, setPartLookupSearchModal] = useState(
        {
            modalOpen:false,
            currentSearch: "",
            searchText: "",
            partIndex: 0,
            workIndex: 0
        });

  const onClickAction = () => {
    if (checkAllFieldsFilled()) {
      save();
      setWork({})
      setOpen(false);
    } else {
      NotificationManager.error("Please fill in all fields", "Error!", 10000);
    }
  };

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  }

  const handleWorkSupplierSelect = supplier => {
    let newWork = {...work}
    newWork.supplier = supplier[0];
    setWork(newWork);
  };

  const handleChange = (e, index) => {
    let newWork = {...work};
    newWork[e.target.name] = e.target.value;
    setWork(newWork);
  };

  const checkAllFieldsFilled = () => {
    if (
      false
    ) {
      return false;
    }
    return true;
  };

  const save = () => {
    const url = endpoint + "worklookup";
    const queryString = getQueryString({
      description: work.description,
      labour_cost: work.labour_cost,
      labour_hours: work.labour_hours,
    });
    return axios.get(`${endpoint}worklookup${queryString}`).then((response) => {
      if(response.data.results.length === 0) {
        const conf = {
          method: "post",
          data: work,
          url
        };
        //
        return axios(conf).then(() => {
          dispatch(createSetDataFreshAction(dataFresh + 1));
          setOpen(false);
        });
      } else {
        NotificationManager.warning("This work already exists!")
      }
    });
  };



  const selectPart = (part, partIndex, workIndex) => {
    let currentParts = []
    if(work.part_work_lookup){
      currentParts = work.part_work_lookup;
    }
    console.log(currentParts);
    console.log(part);
    currentParts.push(part);
    work.part_work_lookup = currentParts;
    setPartLookupSearchModal({modalOpen: false});
  };


  return (
    <Modal
      closeOnBlur
      show={open}
      onClick={e => {e.stopPropagation()}}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content className="wider-modal">
        <Section style={{backgroundColor: "white"}}>
          <Heading className="is-centered">Create New Work Lookup</Heading>
          <Columns>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Description</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="text"
                    name="description"
                    onChange={handleChange}
                    value={work.description || ""}
                    required
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Supplier</Form.Label>
                <Form.Control>
                  <AsyncTypeahead
                    useCache={false}
                    id="typeahead"
                    labelKey="display_name"
                    minLength={2}
                    name={"supplier"}
                    onSearch={handleSearch}
                    onChange={handleWorkSupplierSelect}
                    placeholder={"Search Supplier"}
                    options={searchData}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    isLoading={isLoading}
                    selected={work.supplier && work.supplier.id ? [work.supplier] : []}
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Control>
                <Button
                  onClick={() => setPartModalOpen(true)}
                  color={"success"}
                >
                  Add Part +
                </Button>
              </Form.Control>
            </Columns.Column>
            <Columns.Column>
              <Form.Control>
                <Button
                  onClick={() => (
                      setPartLookupSearchModal({
                          modalOpen: true,
                          currentSearch: "",
                          searchText: "",
                          partIndex: 0,
                          workIndex: 0
                      })
                  )}
                  color={"success"}
                >
                  Search Part
                </Button>
              </Form.Control>
            </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Labour Hours</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="text"
                    name="labour_hours"
                    onChange={handleChange}
                    value={work.labour_hours || ""}
                    required
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Labour Cost</Form.Label>
                <Form.Control className="has-icons-left">
                  <Form.Input
                    type="text"
                    name="labour_cost"
                    onChange={handleChange}
                    value={work.labour_cost || ""}
                    required
                  />
                  <Icon align={"left"} className={"small-icon"}>
                    <FontAwesomeIcon icon={faPoundSign}/>
                  </Icon>
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Customer Labour Charge</Form.Label>
                <Form.Control className="has-icons-left">
                  <Form.Input
                    type="text"
                    name="customer_labour_cost"
                    onChange={handleChange}
                    value={work.customer_labour_cost || ""}
                    required
                  />
                  <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
                </Form.Control>
              </Form.Field>
            </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Button
                color="info"
                fullwidth
                onClick={() => {
                  setWork({});
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
            </Columns.Column>
            <Columns.Column>
              <Button color="danger" fullwidth onClick={onClickAction}>
                Save Work Lookup
              </Button>
            </Columns.Column>
          </Columns>
          <Columns>
            <Table
              size={"fullwidth"}
            >
              <tr className={"table-header-bold"}>
                <th>Part Name</th>
                <th>Part Number</th>
                <th>Supplier</th>
                <th>Cost</th>
                <th></th>
              </tr>
              <tbody>
              {work.part_work_lookup &&
               work.part_work_lookup.map((part, index) => (
                 <PartRow
                  workLookup={work}
                  endpoint={endpoint}
                  dataFresh={dataFresh}
                  index={index}
                 />
               ))
              }
              </tbody>
            </Table>
          </Columns>
          <AddPartModal
            open={partModalOpen}
            setOpen={setPartModalOpen}
            workLookup={work}
            setWorkLookup={setWork}
          />
          <PartSearchModal
            {...partLookupSearchModal}
            setModalState={setPartLookupSearchModal}
            selectPart={selectPart}
          />
        </Section>
      </Modal.Content>
    </Modal>
  );
}
